import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import thunkMiddleware from 'redux-thunk';
import axios from 'axios';

axios.defaults.withCredentials = true;

import App from './components/App';
// import { recordPageView } from './components/parts/cookie_notice.jsx';
import reducer from './reducers';

const loggerMiddleware = createLogger();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, composeEnhancers(
	applyMiddleware(thunkMiddleware, loggerMiddleware)
));
const history = createBrowserHistory()

// history.listen(location => {
// 	recordPageView(location);
// });
ReactDOM.render(
	<Provider store={store}>
		<Router history={history}>
			<App />
		</Router>
	</Provider>,
	document.getElementById('application')
);

module.hot.accept();
